import { postContactForm } from "../../../app/api/postContactForm";
import { BaseAction } from "../../../core/actions/BaseAction";
import { getTranslatedMessage } from "../../../Lib/Utils/i18n";
import { IContactParams } from "../../../Orchestrator/Types/Interface/ICustomerContact";
import { showNotification } from "../../../Services/notificationService";

class HandleSubmitContactAction extends BaseAction<boolean, IContactParams> {
  override async run(): Promise<boolean> {
    if (!this.params) {
      return false;
    }

    try {
      const { data } = this.params;
      const response = await postContactForm(data);
      if (response.status === "ok") {
        const message = getTranslatedMessage("contactSuccessMessage");
        showNotification("success", message, "");
        return true;
      } else {
        console.error("Contact form submission failed:", response.error);
        return false;
      }
    } catch (error: any) {
      console.error("Error submitting contact form:", error);
      return false;
    }
  }
}

export const handleSubmitContactAction = new HandleSubmitContactAction();
